import { useQuery } from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import { getV2PromoCode } from '@hungryroot/rest/api/v2/promo/[code]/get';

function key(promoCode: string) {
  return ['promo', promoCode];
}

type PromoQueryParams = {
  [use_case: string]: string;
};

export interface InvalidPromoCode {
  valid: false;
  message: string;
}

export const getPromoCodeResponse = async (promoCode: string) => {
  const resp = await getV2PromoCode(promoCode);

  if (resp.status === StatusCode.ClientErrorNotFound) {
    return {
      valid: false,
      message: 'invalid promo code',
    } as InvalidPromoCode;
  }

  if (resp.status !== StatusCode.SuccessOK) {
    throw new Error(JSON.stringify(resp.data, null, 2));
  }

  return resp.data;
};

export function usePromoCode(
  promoCode: string,
  queryParams: PromoQueryParams,
  options: { enabled?: boolean }
) {
  const promo = key(promoCode);
  return useQuery({
    queryKey: promo,
    queryFn: async () => {
      const resp = await getV2PromoCode(promoCode, queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    enabled: options.enabled,
    retry: 0,
  });
}
